import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Dashboard from './routes/dashboard/dashboard';
import TopBar from './components/layouts/Topbar';
import Login from './routes/login/Login';
import ProtectedRoute from './components/ProtectedRoute'; // Adjust path as necessary
import { AuthProvider } from './context/AuthContext'; // Adjust path as necessary
import Layout from './components/layouts/MainLayout';
import JobHistory from './routes/jobs/JobHistory';
import Robots from './routes/robots/Robots';
import MainLayout from './components/layouts/MainLayout';
import RobotDetails from './routes/robotDetails/robotDetails';
import ReportHistory from './routes/reportHistory/ReportHistory';
import RoleOverview from './routes/rbac/RoleOverview';
import AddUser from './routes/rbac/users/AddUser';
import AddFeatures from './routes/rbac/features/AddFeatures';
import ScheduledJobPage from './routes/scheduledJob';
import EditUser from './routes/rbac/users/EditUser';
import EditFeatures from './routes/rbac/features/EditFeatures';

import "./global.css"
import RobotDetailPage from './routes/robotDetail';
import OrderHistory from './routes/orders/OrderHistory';
import Robotsv2Page from './routes/robots/v2/Robots-page';
import RobotDetailv2 from './routes/robotDetail/v2';
import ConfigPage from './routes/config/page';
import ConfigLayout from './routes/config/layout';
import ConfigBuildingPage from './routes/config/buildings/page';
import QuickSetupPage from './routes/config/quick-setup/page';
import { NuqsAdapter } from 'nuqs/adapters/react-router/v6'
import PrivacyPolicyPage from './routes/privacy-policy/page';
import TermsOfUsePage from './routes/terms-of-use/page';
import ConfigLayoutMapsPage from './routes/config/layout-maps/page';
import CreateLayoutMapsPage from './routes/config/layout-maps/create/page';
import EditLayoutMapsPage from './routes/config/layout-maps/edit/page';
import ListRobotPage from './routes/config/robot/page';
import CreateRobotPage from './routes/config/robot/create/page';
import ListRobotMapPage from './routes/config/robot-map/page';
import CreateRobotMapPage from './routes/config/robot-map/create/page';
import { isDevMode, isLocal, showConfigPage } from './utils/const';
import ListLocationPage from './routes/config/location/page';
import CreateLocationPage from './routes/config/location/create/page';
import AssignRobotPage from './routes/config/assign-robot/page';
import BindLayoutMapPage from './routes/config/bind-layout-maps/page';
import CreateBindLayoutMapPage from './routes/config/bind-layout-maps/create/page';
import { FireAlarmProvider } from './context/FireAlarmContext';
import ConfigCreateBuilding from './routes/config/buildings/create/page';
import ConfigBuildingDetailPage from './routes/config/buildings/[slug]/page';
import EditRobotMapPage from './routes/config/robot-map/edit/[id]/page';
import EditLocationPage from './routes/config/location/edit/page';
import EditRobotPage from './routes/config/robot/edit/page';

function App() {
  const [notificationCount, setNotificationCount] = React.useState<number>(0);
  const handleNotificationCount = (count: number) => {
    setNotificationCount(count);
  }

  return (
    // <Router basename="/dev">
    <Router basename={isDevMode && !isLocal ? "/dev" : undefined}>
      <AuthProvider>
        <NuqsAdapter>
          <FireAlarmProvider>
            <div style={{ backgroundColor: "#f5f5f5", color: "white", margin: 0, overflow: "hidden" }}>
              <Routes>
                <Route path="/" element={
                  <ProtectedRoute>
                    <MainLayout>
                      <Dashboard onNotificationCountChange={handleNotificationCount} />
                    </MainLayout>
                  </ProtectedRoute>
                } />
                <Route path="/login" element={<Login />} />
                <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
                <Route path="/terms-of-use" element={<TermsOfUsePage />} />
                <Route path='/jobs' element={
                  <ProtectedRoute>
                    <MainLayout>
                      <JobHistory />
                    </MainLayout>
                  </ProtectedRoute>
                }
                />
                {showConfigPage && (
                  <>
                    <Route path='/config' element={
                      <ProtectedRoute>
                        <ConfigLayout>
                          <ConfigPage />
                        </ConfigLayout>
                      </ProtectedRoute>
                    }
                    />
                    <Route path='/config/buildings' element={
                      <ProtectedRoute>
                        <ConfigLayout>
                          <ConfigBuildingPage />
                        </ConfigLayout>
                      </ProtectedRoute>
                    }
                    />
                    <Route path='/config/buildings/create' element={
                      <ProtectedRoute>
                        <ConfigLayout>
                          <ConfigCreateBuilding />
                        </ConfigLayout>
                      </ProtectedRoute>
                    }
                    />
                    <Route path='/config/buildings/:id' element={
                      <ProtectedRoute>
                        <ConfigLayout>
                          <ConfigBuildingDetailPage />
                        </ConfigLayout>
                      </ProtectedRoute>
                    }
                    />
                    <Route path='/config/layout-maps' element={
                      <ProtectedRoute>
                        <ConfigLayout>
                          <ConfigLayoutMapsPage />
                        </ConfigLayout>
                      </ProtectedRoute>
                    }
                    />
                    <Route path='/config/layout-maps/create' element={
                      <ProtectedRoute>
                        <ConfigLayout>
                          <CreateLayoutMapsPage />
                        </ConfigLayout>
                      </ProtectedRoute>
                    }
                    />
                    <Route path='/config/layout-maps/:id' element={
                      <ProtectedRoute>
                        <ConfigLayout>
                          <EditLayoutMapsPage />
                        </ConfigLayout>
                      </ProtectedRoute>
                    }
                    />
                    <Route path='/config/robots' element={
                      <ProtectedRoute>
                        <ConfigLayout>
                          <ListRobotPage />
                        </ConfigLayout>
                      </ProtectedRoute>
                    }
                    />
                    <Route path='/config/robots/create' element={
                      <ProtectedRoute>
                        <ConfigLayout>
                          <CreateRobotPage />
                        </ConfigLayout>
                      </ProtectedRoute>
                    }
                    />
                    <Route path='/config/robots/:id/edit' element={
                      <ProtectedRoute>
                        <ConfigLayout>
                          <EditRobotPage />
                        </ConfigLayout>
                      </ProtectedRoute>
                    }
                    />
                    <Route path='/config/robot-maps' element={
                      <ProtectedRoute>
                        <ConfigLayout>
                          <ListRobotMapPage />
                        </ConfigLayout>
                      </ProtectedRoute>
                    }
                    />
                    <Route path='/config/robot-maps/create' element={
                      <ProtectedRoute>
                        <ConfigLayout>
                          <CreateRobotMapPage />
                        </ConfigLayout>
                      </ProtectedRoute>
                    }
                    />
                    <Route path='/config/robot-maps/edit/:id' element={
                      <ProtectedRoute>
                        <ConfigLayout>
                          <EditRobotMapPage />
                        </ConfigLayout>
                      </ProtectedRoute>
                    }
                    />
                    <Route path='/config/locations' element={
                      <ProtectedRoute>
                        <ConfigLayout>
                          <ListLocationPage />
                        </ConfigLayout>
                      </ProtectedRoute>
                    }
                    />
                    <Route path='/config/locations/create' element={
                      <ProtectedRoute>
                        <ConfigLayout>
                          <CreateLocationPage />
                        </ConfigLayout>
                      </ProtectedRoute>
                    }
                    />
                    <Route path='/config/locations/:id' element={
                      <ProtectedRoute>
                        <ConfigLayout>
                          <EditLocationPage />
                        </ConfigLayout>
                      </ProtectedRoute>
                    }
                    />
                    <Route path='/config/assign-robot' element={
                      <ProtectedRoute>
                        <ConfigLayout>
                          <AssignRobotPage />
                        </ConfigLayout>
                      </ProtectedRoute>
                    }
                    />
                    <Route path='/config/bind-layout-maps' element={
                      <ProtectedRoute>
                        <ConfigLayout>
                          <BindLayoutMapPage />
                        </ConfigLayout>
                      </ProtectedRoute>
                    }
                    />
                    <Route path='/config/bind-layout-maps/create' element={
                      <ProtectedRoute>
                        <ConfigLayout>
                          <CreateBindLayoutMapPage />
                        </ConfigLayout>
                      </ProtectedRoute>
                    }
                    />
                    <Route path='/config/quick-step' element={
                      <ProtectedRoute>
                        <ConfigLayout>
                          <QuickSetupPage />
                        </ConfigLayout>
                      </ProtectedRoute>
                    }
                    />
                  </>
                )}
                {/* <Route path='/config/quick-step/create-building' element={
              <ProtectedRoute>
                <MainLayout>
                <Dashboard onNotificationCountChange={handleNotificationCount} />
                </MainLayout>
              </ProtectedRoute>
            } />
            <Route path="/login" element={<Login />} />
            <Route path='/jobs' element={
              <ProtectedRoute>
                <MainLayout>
                <JobHistory />
                </MainLayout>
                <ConfigLayout>
                  <CreateBuildingPage />
                </ConfigLayout>
              </ProtectedRoute>
            }
            />
            <Route path='/config/quick-step/layout-maps/:id' element={
              <ProtectedRoute>
                <ConfigLayout>
                  <BuildingLayoutMaps />
                </ConfigLayout>
              </ProtectedRoute>
            }
            /> */}
                <Route path='/orders' element={
                  <ProtectedRoute>
                    <MainLayout>
                      <OrderHistory />
                    </MainLayout>
                  </ProtectedRoute>
                }
                />
                <Route path="/robot" element={
                  <ProtectedRoute>
                    <MainLayout>
                      <Robotsv2Page />
                    </MainLayout>
                  </ProtectedRoute>
                } />
                <Route path="/robot/:id" element={
                  <ProtectedRoute>
                    <MainLayout>
                      <RobotDetailv2 />
                    </MainLayout>
                  </ProtectedRoute>
                } />
                <Route path="/reports" element={
                  <ProtectedRoute>
                    <MainLayout>
                      <ReportHistory />
                    </MainLayout>
                  </ProtectedRoute>
                } />
                <Route path="/access-control" element={
                  <ProtectedRoute>
                    <MainLayout>
                      <RoleOverview />
                    </MainLayout>
                  </ProtectedRoute>
                } />
                <Route path="/access-control/new-user" element={
                  <ProtectedRoute>
                    <MainLayout>
                      <AddUser />
                    </MainLayout>
                  </ProtectedRoute>
                } />
                <Route path="/access-control/new-grouping" element={
                  <ProtectedRoute>
                    <MainLayout>
                      {/* <AddUser/> */}
                      <AddFeatures />
                    </MainLayout>
                  </ProtectedRoute>
                } />
                <Route path="/scheduled-job" element={
                  <ProtectedRoute>
                    <MainLayout>
                      <ScheduledJobPage />
                    </MainLayout>
                  </ProtectedRoute>
                } />
                {/* {/* <Route path="/robots/:id" element={ */}
                <Route path="/access-control/edit-user/:id" element={
                  <ProtectedRoute>
                    <MainLayout>
                      <EditUser />
                    </MainLayout>
                  </ProtectedRoute>
                } />

                <Route path="/access-control/edit-grouping/:id" element={
                  <ProtectedRoute>
                    <MainLayout>
                      <EditFeatures />
                    </MainLayout>
                  </ProtectedRoute>
                } />
                <Route path="*" element={<Navigate to="/login" />} />

                <Route path="*" element={<Navigate to="/login" />} />
              </Routes>
            </div>
          </FireAlarmProvider>
        </NuqsAdapter>
      </AuthProvider>
    </Router>
  );
}


export default App;

